(function (){
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .directive('tfcConsumerChartCallout', ConsumerChartCallout)
      .controller('tfcConsumerChartCalloutCtrl', ConsumerChartCalloutCtrl);


  function ConsumerChartCallout(){
    return {
      scope : {
        sectionConfig: '=',
        chartDataFunc: '&',
        apiParams: '='
      },
      controller : 'tfcConsumerChartCalloutCtrl as vm',
      bindToController : true,
      templateUrl : 'StandardReports/ConsumerChartCallout/ConsumerChartCallout.tmpl.html'
    };
  }

  // @ng-inject
  function ConsumerChartCalloutCtrl(ConsumerChart, ChartUtil, StandardReports, AreaLineChartConfig){
    var vm = this;
    vm.section = vm.sectionConfig.section;
    vm.callouts = vm.section.callout.values;

    var customOptions = {
      section: vm.section,
      valuePrefix: vm.section.valuePrefix,
      detailLevel: vm.apiParams.detailLevel,
      custom: {
        xAxisFormatter: function () {
          var formattedDate = moment(this.value).format('DD MMM');
          return _(formattedDate).words().join('<br/>');
        }
      }
    };

    vm.chartOptions = AreaLineChartConfig.getChartOptions(customOptions);

    vm.getData = function() {
      return StandardReports.getConsumerData(vm.section.api, vm.apiParams.detailLevel, vm.apiParams.queryParams)
          .then(function(apiData) {
            return vm.chartDataFunc({rawData: apiData});
          });
    };

    vm.dataOptions = function(rawData) {
      var formattedData = ConsumerChart.getFormattedData(vm.section.chart, rawData.dateMetrics);

      return AreaLineChartConfig.getDataOptions([formattedData], _.merge({}, customOptions, vm.chartOptions));
    };

    vm.setParentValues = function(formattedData) {
      vm.calloutData = formattedData.summary;
    }

    vm.isNumber = function (number) {
      return _.isNumber(number);
    };

    vm.calloutValue = function(userCohort, summaryKey) {
      var summary = _.find(vm.calloutData, {metric: summaryKey});
      if(summary) {
        var userCohortValue = _.find(summary.metricValue, {userCohort: userCohort.value});
        return userCohortValue && _.round(userCohortValue.value,2);
      }
    };

    vm.calloutPercentValue = function(userCohort, summaryKey) {
      var summary = _.find(vm.calloutData, {metric: summaryKey});
      if(summary) {
        var userCohortValue = _.find(summary.metricValue, {userCohort: userCohort.value});
        return userCohortValue && _.round(userCohortValue.percentOfVal,2);
      }
    };

    vm.filteredPct = function(userCohort, summaryKey) {
      var num = vm.calloutValue(userCohort, summaryKey);
      var den = vm.calloutValue(userCohort, 'TotalUsedForReporting');

      return StandardReports.filteredPercent(num, den);
    };

  }

})();